module.exports = __webpack_public_path__ + "img/tu06.558fe534.jpg";